<template>
  <div class="modal_accordion">
    <div
      v-for="(item, itemIndex) in items"
      :key="itemIndex"
      :class="'accordion_wrapper '+(selected === itemIndex ? 'active' : '')"
    >
      <div
        class="accordion_head"
        @click="selected === itemIndex ? selected = null : selected = itemIndex"
      >
        <span class="p_body">{{ item.name }}</span>
        <svg
          fill="none"
          height="16"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 8H13.5"
            stroke="#4E4E54"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.33"
          />
          <path
            d="M8 2.5V13.5"
            stroke="#4E4E54"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.33333"
          />
        </svg>
      </div>
      <accordion-transition>
        <div
          v-show="selected === itemIndex"
          class="accordion_body"
        >
          <ul>
            <li
              v-for="(option, optionIndex) in item.options"
              :key="optionIndex"
              :class="(option.disabled ? 'disabled' : '')"
            >
              <div v-if="option.children">
                <div
                  :class="'accordion_sub_head '+(subSelected === optionIndex ? 'active' : '')"
                  @click="subSelected === optionIndex ? subSelected = null : subSelected = optionIndex"
                >
                  <span class="p_small">{{ option.name }}</span>
                  <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 8H13.5"
                      stroke="#4E4E54"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.33"
                    />
                    <path
                      d="M8 2.5V13.5"
                      stroke="#4E4E54"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.33333"
                    />
                  </svg>
                </div>
                <accordion-transition>
                  <div
                    v-show="subSelected === optionIndex"
                    class="accordion_sub_body"
                  >
                    <ul>
                      <li
                        v-for="(childOption, childIndex) in option.children"
                        :key="childIndex"
                        :class="(childOption.disabled ? 'disabled' : '')"
                      >
                        <a
                          class="p_small"
                          href="javascript:;"
                          @click="$emit('selected', childOption)"
                        >{{ childOption.name }}</a>
                      </li>
                    </ul>
                  </div>
                </accordion-transition>
              </div>

              <a
                v-else
                class="p_small"
                href="javascript:;"
                @click="$emit('selected', option)"
              >{{ option.name }}</a>
            </li>
          </ul>
        </div>
      </accordion-transition>
    </div>
  </div>
</template>

<script>
import AccordionTransition from './../../global/transitions/AccordionTransition.vue'

export default {
  components: {
    AccordionTransition
  },
  props: {
    items: {
      type: Object,
      required: true
    },
    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  emits: ['selected'],
  data() {
    return {
      selected: 0,
      subSelected: null
    }
  },
  mounted() {
    this.selected = this.selectedIndex;
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
}

.modal_accordion {
  overflow: hidden;
}

.modal_accordion {
  border: 1px solid #E8E5E2;
  background-color: #fff;
  border-radius: 0.75rem;
}

.accordion_wrapper {
  border-bottom: 1px solid #E8E5E2;
}

.accordion_wrapper:last-of-type {
  border-bottom: none;
}

.accordion_wrapper.active .accordion_head {
  background-color: #DFF5EE;
}

.accordion_wrapper.active .accordion_head span {
  color: #0A8080;
}

.accordion_wrapper.active .accordion_head svg path, .accordion_sub_head.active svg path {
  stroke: #0A8080;
}

.accordion_wrapper.active .accordion_head svg path:last-of-type, .accordion_sub_head.active svg path:last-of-type {
  opacity: 0;
}

.accordion_head, .accordion_sub_head {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.accordion_head {
  padding: 0.875rem 1rem;
}

.accordion_head:hover, .accordion_sub_head:hover {
  background-color: #37B2A8;
}

.accordion_head:hover .p_body, .accordion_sub_head:hover .p_small {
  color: #FFF;
}

.accordion_head:hover svg path, .accordion_sub_head:hover svg path {
  stroke: #FFF;
}

.accordion_sub_head.active .p_small {
  color: #0A8080;
}

.accordion_sub_head.active svg path {
  stroke: #0A8080;
}

.accordion_sub_head {
  padding: 15px 1rem 15px 2rem;
}

.accordion_head span {
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.accordion_head Svg path {
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.accordion_body ul li a {
  display: block;
  padding: 15px 2rem;
  border-bottom: 1px solid #E8E5E2;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.accordion_body ul li a:hover {
  background-color: #37B2A8;
  color: #fff;
}

.accordion_body ul li:first-of-type a {
  /*border-top: 1px solid #E8E5E2;*/
}

.accordion_body ul li:last-of-type a {
  border: none;
}

.disabled {
  background-color: #E8E5E2;
}

.accordion_head {
  cursor: pointer;
}

.accordion_body, .accordion_sub_body {
  transition: 300ms;
}

.accordion_body > ul {
  margin-bottom: 0;
}

.accordion_wrapper.active .accordion_sub_head {
  border-bottom: 1px solid #E8E5E2;
}

.accordion_wrapper.active .accordion_sub_head.active {
  background: #DFF5EE;
}

.accordion_body > ul > li > div > div.accordion_sub_body > ul > li > a {
  padding: 15px 1rem 15px 3rem;
  border-bottom: 1px solid #E8E5E2;
}
</style>
